import l10n from '../../../shared/strings';

export const resolveChannelLabel = (channelId, salesChannels = []) => {
  const normalizedChannelId = String(channelId);

  const byId = salesChannels.find(
    (salesChannel) => String(salesChannel._id) === normalizedChannelId,
  );
  if (byId?.name) return byId.name;

  const byName = salesChannels.find(
    (salesChannel) => salesChannel.name === normalizedChannelId,
  );
  if (byName?.name) return byName.name;

  const byType = salesChannels.find(
    (salesChannel) => salesChannel.type === normalizedChannelId,
  );
  if (byType?.name) return byType.name;

  return `${normalizedChannelId.charAt(0).toUpperCase()}${normalizedChannelId.slice(1)}`;
};

export const resolveChannelLabels = (channelIds = [], salesChannels = []) => (
  channelIds.map((channelId) => resolveChannelLabel(channelId, salesChannels))
);

export const showPublishedToChannelToast = ({
  Toast,
  channelId,
  channelIds,
  salesChannels = [],
}) => {
  const resolvedChannelIds = channelIds?.length
    ? channelIds
    : (channelId ? [channelId] : []);

  if (!resolvedChannelIds.length) {
    return;
  }

  if (resolvedChannelIds.length === 1) {
    const channelLabel = resolveChannelLabel(resolvedChannelIds[0], salesChannels);
    Toast(l10n.TOAST.PUBLISHED_TO_CHANNEL(channelLabel), { type: 'success' });
    return;
  }

  const channelLabels = resolveChannelLabels(resolvedChannelIds, salesChannels);
  Toast(l10n.TOAST.PUBLISHED_TO_CHANNELS(channelLabels), { type: 'success' });
};
